import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=158cfb2c&scoped=true&"
import script from "./Box.vue?vue&type=script&lang=js&"
export * from "./Box.vue?vue&type=script&lang=js&"
import style0 from "./Box.vue?vue&type=style&index=0&id=158cfb2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158cfb2c",
  null
  
)

export default component.exports